export default __webpack_public_path__ + "static/media/FMG.bed38df9.gif";